<app-account-subform-shell
  titleId="account-sms-opt-in-title"
  [crumb]="'Account settings / Alerts' | translate"
  [title]="'Get LEAP alerts by text' | translate"
  variant="tall"
  (back)="cancelled.emit()"
>
  <div class="field field-loose">
    <label for="account-sms-phone"
      >{{ 'Mobile number' | translate }}
      <span class="label-optional">{{ '(optional)' | translate }}</span></label
    >
    <div class="phone" [class.phone-invalid]="phoneInvalid">
      <select
        class="phone-country"
        name="smsCountry"
        [attr.aria-label]="'Country code' | translate"
        [(ngModel)]="country"
      >
        @for (option of countryOptions; track trackById($index, option)) {
          <option [value]="option.id">{{ option.name }} +{{ option.dialCode }}</option>
        }
      </select>
      <input
        id="account-sms-phone"
        class="phone-input"
        type="tel"
        inputmode="tel"
        autocomplete="tel-national"
        placeholder="(000) 000-0000"
        aria-describedby="account-sms-phone-hint"
        [value]="localNumber"
        (input)="onPhoneInput($event)"
        (blur)="onPhoneBlur()"
      />
    </div>
    @if (phoneInvalid) {
      <span class="hint hint-error" id="account-sms-phone-hint">{{
        'Enter a valid 10-digit US or Canada phone number.' | translate
      }}</span>
    } @else {
      <span class="hint" id="account-sms-phone-hint">{{ 'United States and Canada only.' | translate }}</span>
    }
  </div>

  <div class="agree">
    <div class="agree-kicker">
      <app-account-icon name="file-text"></app-account-icon>
      <h2>{{ 'WHAT YOU ARE AGREEING TO' | translate }}</h2>
    </div>
    <p>
      <strong>{{ 'Applied Particle Technology' | translate }}</strong>
      {{
        'will text you the LEAP notifications that you or your site administrator set up for you to receive, such as sensor threshold alerts, equipment calibration reminders and alert follow-ups.'
          | translate
      }}
    </p>
    <p>
      {{ 'Message frequency varies. Message and data rates may apply. Reply' | translate }}
      <span class="token">{{ 'HELP' | translate }}</span>
      {{ 'for help. Reply' | translate }}
      <span class="token">{{ 'STOP' | translate }}</span>
      {{ 'to cancel.' | translate }}
    </p>
    <p>
      {{ 'See our' | translate }}
      <a target="_blank" rel="noopener noreferrer" href="/sms-terms/">{{ 'SMS Terms & Conditions' | translate }}</a>
      {{ 'and' | translate }}
      <a target="_blank" rel="noopener noreferrer" href="/sms-privacy/">{{
        'Privacy Policy' | translate
      }}</a
      >.
    </p>
  </div>

  <label class="consent" [class.consent-checked]="consentChecked">
    <input
      type="checkbox"
      class="consent-input"
      [checked]="consentChecked"
      (change)="onConsentChange($event)"
    />
    <span class="consent-text"
      ><b>{{ 'Yes — text me my LEAP notifications at this number.' | translate }}</b>
      <small>{{ 'Optional. Your email alerts continue either way.' | translate }}</small></span
    >
  </label>

  <div subformFooter class="footer-actions">
    <button type="button" class="as-btn-secondary" (click)="cancelled.emit()">
      {{ 'Cancel' | translate }}
    </button>
    <button type="button" class="as-btn-primary enable-sms" [disabled]="!canSubmit" (click)="submit()">
      {{ 'Enable SMS alerts' | translate }}
    </button>
  </div>
</app-account-subform-shell>
